/* Sincroniza la galeria y evita el refresco visible al cambiar color/talla.
   1) Escritorio: la foto principal sigue a la variante elegida (el carrusel de galeria-claude.js no se enteraba).
   2) Si la variante elegida tiene el mismo precio que la actual (aunque haya tallas/colores agotados), se resuelve en el
      navegador (sin pedir la seccion al servidor ni repintar la ficha) y se actualiza la disponibilidad de las opciones.
      En cualquier otro caso (precio distinto, planes de suscripcion...) se usa el flujo original.
   3) Calienta en segundo plano la foto de cada color para que el cambio de color no espere a la red.
   (29-oct) Orden de carga: joyas-upsell-claude.js reemplazaba refresh() y anulaba este atajo (cada talla/color pedia 175 KB al servidor).
   Ahora patch() se puede volver a aplicar (window.__mfFastPatch) y joyas-upsell lo llama tras poner su refresh; ademas __mfFastReady() le dice
   a la precarga de joyas-upsell que no pida la seccion cuando el atajo local va a resolver la eleccion. */
(function () {
  'use strict';
  var TAG = 'mf-product-information';
  var DESK = window.matchMedia('(min-width: 990px)');
  var cache = {};

  function file(u) { return String(u || '').split('?')[0].split('/').pop(); }

  /* ---------- 1) galeria de escritorio ---------- */
  function syncGallery(host) {
    var span0 = host.querySelector('[data-featured-media]');
    var last = (span0 && span0.dataset.featuredMedia) || '';
    function run() {
      if (!DESK.matches) return;
      var f = host.querySelector('[data-featured-media]');
      var id = f && f.dataset.featuredMedia;
      if (!id || id === last) return;
      last = id;
      var wrap = host.querySelector('[data-gallery-wrap]');
      var go = window.__mfgGo;
      if (!wrap || typeof go !== 'function') return;
      var media = wrap.querySelector('.mf-media[data-media-id="' + id + '"]');
      var zoom = media && media.querySelector('[data-zoom-src]');
      if (!zoom) return;
      var key = file(zoom.dataset.zoomSrc);
      var thumbs = wrap.querySelectorAll('.mfg-thumb');
      for (var i = 0; i < thumbs.length; i++) {
        var im = thumbs[i].querySelector('img');
        if (im && file(im.getAttribute('src')) === key) { go(i); return; }
      }
    }
    new MutationObserver(run).observe(host, { childList: true, subtree: true });
  }

  /* ---------- 2) cambio de variante sin refresco ---------- */
  function load(host) {
    var url = (host.dataset.productUrl || '').split('?')[0];
    if (!url) return null;
    if (!cache[url]) {
      cache[url] = { data: null };
      cache[url].p = fetch(url + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { cache[url].data = j; return j; })
        .catch(function () { return null; });
    }
    return cache[url];
  }

  function valueName(input) {
    var label = input.id && host_label(input);
    var t = label ? (label.getAttribute('title') || label.textContent) : '';
    return String(t).split(' — ')[0].trim();
  }
  function host_label(input) {
    var n = input.nextElementSibling;
    return n && n.tagName === 'LABEL' ? n : null;
  }

  function resolve(host) {
    var c = cache[(host.dataset.productUrl || '').split('?')[0]];
    var data = c && c.data;
    if (!data || !data.variants || !data.variants.length) return null;
    if ((data.selling_plan_groups && data.selling_plan_groups.length) || host.querySelector('[data-plan]')) return null;
    var fieldsets = host.querySelectorAll('[data-option-position]');
    if (!fieldsets.length) return null;
    var names = [], ids = [];
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var pos = parseInt(fs.dataset.optionPosition, 10);
      var inp = fs.querySelector('input:checked');
      if (!inp) {
        var sv = fs.dataset.selectedValue;
        var all = fs.querySelectorAll('input[data-option-value-id]');
        for (var k = 0; k < all.length; k++) if (all[k].value === sv) inp = all[k];
      }
      if (!inp || !inp.value) return null;
      var nm = valueName(inp);
      if (!nm) return null;
      names[pos - 1] = nm;
      ids.push(inp.value);
    }
    var variant = null;
    for (var j = 0; j < data.variants.length; j++) {
      var v = data.variants[j], ok = true;
      for (var m = 0; m < names.length; m++) if (names[m] != null && v.options[m] !== names[m]) { ok = false; break; }
      if (ok) { variant = v; break; }
    }
    if (!variant) return null;
    /* solo se resuelve en el navegador si el precio no cambia respecto a la variante mostrada */
    var vid0 = host.querySelector('[data-variant-id]'), cur = null;
    if (vid0 && vid0.value) {
      for (var z = 0; z < data.variants.length; z++) if (String(data.variants[z].id) === vid0.value) { cur = data.variants[z]; break; }
    }
    if (!cur || cur.price !== variant.price || cur.compare_at_price !== variant.compare_at_price) return null;
    return { variant: variant, names: names, ids: ids, fieldsets: fieldsets, data: data };
  }

  /* disponibilidad de cada opcion segun la combinacion elegida (lo que antes devolvia el servidor) */
  function updateAvail(host, info) {
    var btn = host.querySelector('[data-add]');
    var sold = (btn && btn.dataset.soldLabel) || '';
    for (var f = 0; f < info.fieldsets.length; f++) {
      var fs = info.fieldsets[f];
      var pos = parseInt(fs.dataset.optionPosition, 10) - 1;
      var inputs = fs.querySelectorAll('input[data-option-value-id]');
      for (var k = 0; k < inputs.length; k++) {
        var inp = inputs[k], nm = valueName(inp);
        if (!nm) continue;
        var ok = info.data.variants.some(function (v) {
          if (!v.available || v.options[pos] !== nm) return false;
          for (var q = 0; q < info.names.length; q++) if (q !== pos && info.names[q] != null && v.options[q] !== info.names[q]) return false;
          return true;
        });
        if (inp.dataset.available === String(ok)) continue;
        inp.dataset.available = String(ok);
        var lb = host_label(inp);
        if (!lb) continue;
        var attr = lb.hasAttribute('title') ? 'title' : (lb.hasAttribute('data-n') ? 'data-n' : '');
        if (attr) lb.setAttribute(attr, ok || !sold ? nm : nm + ' — ' + sold);
        var sr = lb.querySelector('.mf-sr-only');
        if (ok && sr) sr.remove();
        else if (!ok && !sr && sold) { var sp = document.createElement('span'); sp.className = 'mf-sr-only'; sp.textContent = ' — ' + sold; lb.appendChild(sp); }
      }
    }
  }

  /* ---------- 3) fotos de cada color en caliente ---------- */
  function warm(host) {
    if (navigator.connection && navigator.connection.saveData) return;
    var c = cache[(host.dataset.productUrl || '').split('?')[0]];
    var data = c && c.data;
    if (!data || !data.variants) return;
    var seen = {}, ids = [];
    data.variants.forEach(function (v) {
      var id = v.featured_media && v.featured_media.id;
      if (id && !seen[id]) { seen[id] = 1; ids.push(id); }
    });
    var i = 0;
    (function next() {
      if (i >= ids.length) return;
      var img = host.querySelector('.mf-media[data-media-id="' + ids[i++] + '"] img');
      if (img && img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
        if (img.decode) img.decode().catch(function () {});
      }
      setTimeout(next, 300);
    })();
  }

  function patch(Ctor) {
    var orig = Ctor.prototype.refresh;
    if (!orig || orig.__fast) return;
    var fast = function (focusId) {
      var info = resolve(this);
      if (!info) return orig.call(this, focusId);
      var host = this, v = info.variant;
      if (host.request) host.request.abort();
      var vid = host.querySelector('[data-variant-id]');
      if (vid) { vid.value = String(v.id); vid.disabled = false; }
      var addBtn = host.querySelector('[data-add]');
      if (addBtn) addBtn.dataset.purchasable = String(!!v.available);
      updateAvail(host, info);
      var cn = host.querySelector('.mf-color-name');
      if (cn) {
        var cfs = cn.closest('[data-option-position]');
        if (cfs) cn.textContent = info.names[parseInt(cfs.dataset.optionPosition, 10) - 1] || cn.textContent;
      }
      var span = host.querySelector('[data-featured-media]');
      if (span && v.featured_media && v.featured_media.id) span.dataset.featuredMedia = String(v.featured_media.id);
      var u = new URL(location.href);
      u.searchParams.delete('section_id');
      u.searchParams.delete('selling_plan');
      if (!host.waiting) { u.searchParams.set('variant', String(v.id)); u.searchParams.delete('option_values'); }
      else { u.searchParams.set('option_values', info.ids.join(',')); u.searchParams.delete('variant'); }
      if (!(window.Shopify && window.Shopify.designMode)) history.replaceState({}, '', u);
      host.loading = false;
      host.failed = false;
      host.removeAttribute('aria-busy');
      var err = host.querySelector('[data-error]'); if (err) err.hidden = true;
      if (host.updateFeaturedMedia) host.updateFeaturedMedia();
      if (host.updateButton) host.updateButton();
      if (host.broadcastPrice) host.broadcastPrice();
      return Promise.resolve();
    };
    fast.__fast = true;
    Ctor.prototype.refresh = fast;
  }

  /* (29-oct) para que joyas-upsell-claude.js pueda volver a envolver su refresh() y para saber si el atajo local esta listo */
  window.__mfFastPatch = patch;
  window.__mfFastReady = function (host) {
    var c = cache[(host.dataset.productUrl || '').split('?')[0]];
    var data = c && c.data;
    return !!(data && data.variants && data.variants.length && !(data.selling_plan_groups && data.selling_plan_groups.length) && !host.querySelector('[data-plan]'));
  };

  function boot() {
    document.querySelectorAll(TAG).forEach(function (h) {
      if (h.__mfSync) return;
      h.__mfSync = true;
      syncGallery(h);
      var entry = load(h);
      if (entry && entry.p) entry.p.then(function () {
        var go = function () { (window.requestIdleCallback || function (fn) { setTimeout(fn, 800); })(function () { warm(h); }); };
        if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
      });
    });
  }

  customElements.whenDefined(TAG).then(function (C) { patch(C); boot(); });
  /* red de seguridad por si otro script reemplaza refresh() despues */
  window.addEventListener('load', function () { var C = customElements.get(TAG); if (C) patch(C); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();